import { render, staticRenderFns } from "./phone-login.vue?vue&type=template&id=491a3f62&scoped=true&"
import script from "./phone-login.vue?vue&type=script&lang=js&"
export * from "./phone-login.vue?vue&type=script&lang=js&"
import style0 from "./phone-login.vue?vue&type=style&index=0&id=491a3f62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a3f62",
  null
  
)

export default component.exports